<template>
  <div class="layout-nav-bar" :class="{'bordered': border}">
    <div class="head">
      <slot name="title"
            :title="title"
            :back="handleBack">
        <div class="title">
          <el-button type="text"
                     icon="el-icon-arrow-left"
                     @click="handleBack"></el-button>
          <span class="label">{{title}}</span>
        </div>
      </slot>
    </div>
    <div class="tail">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
    title: {
      type: String
    },
    border: Boolean
  },
  methods: {
    handleBack () {
      this.$emit('back')
    }
  }
}
</script>

<style lang="scss">
  .layout-nav-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    padding: 5px 24px 5px 8px;
    box-sizing: border-box;
    &.bordered {
      border-bottom: 1px solid #ebeef5;
    }
    & > .head {
      & > .title {
        .el-button {
          width: 30px;
          padding: 9px 0;
          i {
            font-size: 16px;
            font-weight: bold;
          }
        }
        .label {
          margin-left: 2px;
          font-size: 13px;
          vertical-align: 1px;
        }
      }
    }
  }
</style>
